import { Button } from '@mui/material';
import { styled } from 'styled-components';

import CommonButtonIconWithText from '../ButtonIconWithText';

export const ButtonIconWithText = styled(CommonButtonIconWithText)`
  justify-content: space-between;
  padding: var(--spacing-small) 0;
`;

export const MuiButton = styled(Button)`
  padding: var(--spacing-small) var(--spacing-medium);
  /* stylelint-disable-next-line selector-class-pattern */
  .MuiButtonBase-root {
    justify-content: flex-start;
  }
`;
